module.exports = __webpack_public_path__ + "img/blue.71cdba3.svg";